import { Typography, useTheme } from '@mui/material';

import { getStyled } from './styles';

export default function Title(props) {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Typography variant='h5' sx={classes.title} gutterBottom>
      {props.children}
    </Typography>
  );
}
